import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import "./App.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';


import React, { Suspense, lazy } from "react";

const Home = lazy(() => import("./pages/Home"));
const About = lazy(() => import("./pages/About"));
const WhatWeOffer = lazy(() => import("./pages/WhatWeOffer"));
const HowItWorks = lazy(() => import("./pages/HowItWork"));
const BookASession = lazy(() => import("./pages/BookASession"));
const ContactUs = lazy(() => import("./components/ContactUs"));
const TermsAndConditions = lazy(() => import("./pages/TermsAndConditions"));
const PrivacyPolicy = lazy(() => import("./pages/PrivacyPolicy"));
const RefundCancellationPolicy = lazy(() => import("./pages/RefundCancellationPolicy"));
const Disclaimer = lazy(() => import("./pages/Disclaimer"));



function App() {
  return (
    <Router>
      <ScrollToTop />   {/* <-- Add this here */}
      <div className="App">
        <Navbar/>

        <Suspense fallback={<div className="text-center mt-5">Loading...</div>}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/what-we-offer" element={<WhatWeOffer />} />
            <Route path="/how-it-works" element={<HowItWorks />} />
            <Route path="/book-session" element={<BookASession />} />
            <Route path="/contact" element={<ContactUs />} />
            <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/refund-cancellation" element={<RefundCancellationPolicy />} />
            <Route path="/disclaimer" element={<Disclaimer />} />
          </Routes>
        </Suspense>

        <Footer />
      </div>
    </Router>
  );
}

export default App;
